import { baseApi } from "@/redux/api/baseApi";

const submitApplicationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitApplication: builder.mutation({
      query: (payload) => ({
        url: "/creatorApplication/submit-application",
        method: "POST",
        body: payload,
      }),
      invalidatesTags:['User']
    }),
  }),
});

export const {useSubmitApplicationMutation} = submitApplicationApi;
